import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { getStudentAbsencesByStudentNo, getStudentAttendanceStreak } from "./api"

export const studentAbsencesQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentAbsences', studentNo],
        queryFn: () => getStudentAbsencesByStudentNo(studentNo),
    })

export function useStudentAbsences(studentNo: string) {
    return useQuery(studentAbsencesQueryOptions(studentNo))
}

export function useStudentAbsencesSuspense(studentNo: string) {
    return useSuspenseQuery(studentAbsencesQueryOptions(studentNo))
}

export const studentAttendanceStreakQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentAttendanceStreak', studentNo],
        queryFn: () => getStudentAttendanceStreak(studentNo),
    })

export function useStudentAttendanceStreak(studentNo: string) {
    return useQuery(studentAttendanceStreakQueryOptions(studentNo))
}

export function useStudentAttendanceStreakSuspense(studentNo: string) {
    return useSuspenseQuery(studentAttendanceStreakQueryOptions(studentNo))
}
